<template>
    <div class="layers">
        <div v-if="show" v-click-outside="hide"></div>
        <!--BEGIN TOGGLE-->
        <div class="toggle">
            <button type="button" class="toggle__btn shade" @click="toggle()" :class="isActive">
                <svg class="toggle__icon" width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path class="toggle__path" d="M16.6978 21.1502C16.8113 21.2112 16.9374 21.2452 17.0662 21.2494C17.1959 21.2522 17.3237 21.2178 17.4345 21.1502L33.7278 11.2326C33.8301 11.1673 33.9144 11.0773 33.9728 10.9708C34.0312 10.8643 34.0618 10.7448 34.0618 10.6234C34.0618 10.502 34.0312 10.3825 33.9728 10.276C33.9144 10.1695 33.8301 10.0795 33.7278 10.0142L17.4345 0.0965633C17.3221 0.0332572 17.1952 0 17.0662 0C16.9371 0 16.8103 0.0332572 16.6978 0.0965633L0.404601 10.0142C0.302213 10.0795 0.217933 10.1695 0.159548 10.276C0.101163 10.3825 0.0705566 10.502 0.0705566 10.6234C0.0705566 10.7448 0.101163 10.8643 0.159548 10.9708C0.217933 11.0773 0.302213 11.1673 0.404601 11.2326L16.6978 21.1502Z"/>
                    <path class="toggle__path" d="M30.8232 14.6611L18.1712 22.3544C17.8388 22.5586 17.4563 22.6667 17.0661 22.6667C16.6759 22.6667 16.2934 22.5586 15.961 22.3544L3.30897 14.6611L0.475364 16.4321C0.372851 16.4957 0.288256 16.5843 0.229592 16.6897C0.170927 16.7951 0.140137 16.9137 0.140137 17.0343C0.140137 17.1549 0.170927 17.2735 0.229592 17.3789C0.288256 17.4842 0.372851 17.5729 0.475364 17.6364L16.7686 27.554C16.8806 27.6187 17.0076 27.6527 17.1369 27.6527C17.2663 27.6527 17.3933 27.6187 17.5053 27.554L33.7985 17.6364C33.901 17.5729 33.9856 17.4842 34.0443 17.3789C34.103 17.2735 34.1338 17.1549 34.1338 17.0343C34.1338 16.9137 34.103 16.7951 34.0443 16.6897C33.9856 16.5843 33.901 16.4957 33.7985 16.4321L30.8232 14.6611Z"/>
                    <path class="toggle__path" d="M30.8803 21.0371L18.1291 28.7728C17.7935 28.9682 17.4122 29.0712 17.024 29.0712C16.6357 29.0712 16.2544 28.9682 15.9189 28.7728L3.16765 21.0371L0.334045 22.7656C0.231656 22.8309 0.147376 22.921 0.0889912 23.0274C0.0306063 23.1339 0 23.2534 0 23.3748C0 23.4963 0.0306063 23.6157 0.0889912 23.7222C0.147376 23.8287 0.231656 23.9188 0.334045 23.9841L16.6273 33.9017C16.7393 33.9663 16.8663 34.0004 16.9956 34.0004C17.1249 34.0004 17.252 33.9663 17.364 33.9017L33.6572 23.9841C33.7596 23.9188 33.8439 23.8287 33.9023 23.7222C33.9606 23.6157 33.9912 23.4963 33.9912 23.3748C33.9912 23.2534 33.9606 23.1339 33.9023 23.0274C33.8439 22.921 33.7596 22.8309 33.6572 22.7656L30.8803 21.0371Z"/>
                </svg>
            </button>
        </div>
        <!--END TOGGLE-->

        <!--BEGIN LAYERS-->
        <transition name="fade">
            <div class="layers__inner sub shade" v-if="show && services">
                <div class="layers__header">
                    {{ $t("layersTitle") }}
                </div>
                <div class="layers__body">
                    <ul class="layers__list">
                        <li class="layer__item" >
                            <div class="layer__action">
                                <v-checkbox
                                        v-model="isCheckAll"
                                        type="checkbox"
                                        required
                                        hide-details
                                        @change="checkAll"
                                        color="#2C64FF"
                                        :ripple="false"
                                >
                                    <div class="layer__content" slot="label">
                                        <div class="layer__title ml-0">
                                            {{ $t("layersSelectAll") }}
                                        </div>
                                    </div>

                                </v-checkbox>

                            </div>
                        </li>
                        <li class="layer__item" v-for="layer in services" :key="layer.id">
                            <div class="layer__action">
                                <v-checkbox
                                        v-model="checkbox"
                                        :value="layer.id"
                                        type="checkbox"
                                        required
                                        hide-details
                                        checked="true"
                                        @change="checkboxChangeHandler($event)"
                                        color="#2C64FF"
                                        :ripple="false"
                                >
                                    <div class="layer__content" slot="label">
                                        <div class="layer__box" :style="servicesBoxStyle(layer.color_hex)"></div>
                                        <div class="layer__title">
                                            {{layer.name}}
                                        </div>
                                    </div>

                                </v-checkbox>

                            </div>
                        </li>

                    </ul>
                </div>

            </div>
        </transition>
        <!--END LAYERS-->
    </div>
</template>


<script>
    import toggle from '@/mixins/toggle.vue'
    import Services from '@/mixins/services.vue'
    export default {
        mixins: [toggle, Services],
        data() {
          return {
              interval: null,
          }
        },
        props: {
          list: {
              type: Array
          }
        },
        watch: {
            list(val) {
                if(val ) {
                    this.saveServices(val)
                    this.intervalExpiration();
                }
            },
            getCurrentServices(services) {
                if(services) {
                    this.checkbox = services;
                    this.isCheckAll = this.updateCheckall;
                }
            }
        },
        methods: {
            checkExpiration (){
                //check if past expiration date
                let layers = localStorage.getItem('services')
                let exp = layers ? JSON.parse(layers).exp : false;
                //check "my hour" index here
                if (!exp || exp <= new Date().getTime()) {
                    this.clearInterval();
                    localStorage.removeItem("services")
                    this.fetchLayers().then(() => this.intervalExpiration())
                }
            },
            intervalExpiration() {
//                this.interval = setInterval(() => {
                this.interval = setTimeout(() => {
                    this.checkExpiration()
                }, 1000)
            },
            clearInterval() {
                clearTimeout(this.interval)
            },
            async fetchLayers() {
                return await this.$store.dispatch('fetchLayers').then(response => this.saveServices(response.data.data.layers))
            },
        },
        computed: {
            getCurrentServices() {
                return this.$store.getters.getCurrentServices
            }
        },
        mounted() {
            this.popupItem = this.$el
        },
        created() {
            let servicesFromStorage = JSON.parse(localStorage.getItem('services'))
            if(servicesFromStorage) {
                this.saveServices(servicesFromStorage.data)
                this.intervalExpiration();
            }

        },
        beforeDestroy() {
            this.clearInterval();
        }
    }
</script>

<style lang="sass">
    .layers
        width: 100%
        z-index: 12
        position: relative
        &__inner
            color: $color--dark
            font-size: 16px
            z-index: 12
            width: 230px
        &__list
            padding: 0!important
            margin: 0
            overflow-y: auto
            max-height: 430px
            scrollbar-color: #B3BECA
            scrollbar-width: thin
            height: 100%
            &::-webkit-scrollbar
                width: 4px
                background: white
                scrollbar-width: 4px
                height: 122px
                /*display: none*/
            &::-moz-scrollbar,
            &::-o-scrollbar
                /*display: none*/
                scrollbar-width: 4px
                height: 22px
            &::-webkit-scrollbar-track,
            &::-webkit-scrollbar-thumb
                background-color: white
                -ms-overflow-style: none
                scrollbar-width: 4px
                height: 22px
                /*display: none*/
            &::-webkit-scrollbar-thumb
                background: #B3BECA
        &__header
            padding: 12px
            font-size: 18px
            +medium
            text-align: left
    .toggle
        display: flex
        justify-content: flex-end
        &__btn
            width: 60px
            height: 60px
            outline: 0
            display: flex
            justify-content: center
            align-items: center
            &:hover,
            &.is-active
                .toggle__path
                    fill: $color--blue
        &__path
            +tr(fill .3s ease)
            fill: $color--dark
    .layer
        &__item
            display: flex
            padding: 12px
            border-top: 1px solid #D7DDE1
            background-color: transparent
            +tr(background-color .3s ease)
            &:hover
                background-color: rgba(44, 100, 255, 0.05)
        &__box
            width: 24px
            height: 24px
            border-radius: 2px
            background-color: transparent
            +tr(background-color .3s ease-in)
            margin-top: -1px
        &__content
            margin-left: 12px
            display: flex
            justify-content: center
            align-items: flex-start
        &__title
            margin-left: 12px
            line-height: 22px
            +reg

    .v-input--checkbox
        ::v-deep
            .v-input--selection-controls__input
                margin: 0!important

</style>